import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import type { ThemeOptions } from '@mui/material/styles';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import palette, { ALPHAS } from './palette';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';

interface LightModeThemeProps {
  children: ReactNode;
}

export default function LightModeTheme({ children }: LightModeThemeProps) {
  const outerTheme = useTheme();

  const themeOptions: ThemeOptions = useMemo(
    () => ({
      ...outerTheme,
      palette: {
        ...palette.light,
        mode: 'light',
        primary: outerTheme.palette.primary
      },
      shadows: shadows.light,
      customShadows: {
        ...customShadows.light,
        primary: outerTheme.customShadows?.primary ?? customShadows.light.primary
      },
      alphas: ALPHAS
    }),
    [outerTheme]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
